import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6c09d44e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "contents"
};
const _hoisted_2 = {
  class: "t-ripos"
};
const _hoisted_3 = {
  class: "h_boxs"
};
const _hoisted_4 = {
  class: "posha_s"
};
const _hoisted_5 = {
  class: "_ri_ps"
};
const _hoisted_6 = {
  class: "span_text"
};
const _hoisted_7 = {
  class: "box_psl"
};
const _hoisted_8 = {
  key: 0,
  class: "margin-t10 box_Cents animate__animated animate__fadeInLeft"
};
const _hoisted_9 = {
  key: 1,
  class: "animate__animated animate__fadeInRight"
};
const _hoisted_10 = {
  class: "_pagin"
};
const _hoisted_11 = {
  key: 0,
  class: "_pagin_left"
};
import { reactive, ref, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import itemDetile from "./item-detile.vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { getCaseListApi, getCaseCategoryListApi, getCaseTopicListApi, batchCaseApi, batchDeleteCaseApi } from "@/service/modules/case";
import tableList from "./table-list.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'note-list',
  emits: ["pubsnote"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const form = reactive({
      title: "",
      cate_id: "",
      topic_id: "",
      type: "",
      sort: "id-desc"
    });
    const actives = ref(1);
    const cate_List = ref([]);
    const pictop_List = ref([]);
    const type_List = ref([{
      id: 1,
      name: "图文"
    }, {
      id: 2,
      name: "视频"
    }]);
    const date = ref([]);
    const emit = __emit;
    function hald_seach(type = "") {
      if (type == "rest") {
        form.title = "";
        form.cate_id = "";
        form.topic_id = "";
        form.type = "";
        date.value = [];
      }
      page.value.page = 1;
      get_list();
    }
    const page = ref({
      page: 1,
      pageSize: 15
    });
    const total = ref(0);
    const tablist = ref([{
      label: "全部",
      name: "0"
    }, {
      label: "已上架",
      name: "1"
    }, {
      label: "已下架",
      name: "2"
    }]);
    const tabsActive = ref("0");
    async function pubnote() {
      emit("pubsnote", -1);
    }
    const loading = ref(false);
    //获取案例分类
    const cate_lists = async () => {
      let reqdata = {
        page: 1,
        pageSize: 99
      };
      const res = await getCaseCategoryListApi(reqdata);
      cate_List.value = res.data.data;
    };
    const pictop_List_s = async () => {
      let reqdata = {
        page: 1,
        pageSize: 99
      };
      const res = await getCaseTopicListApi(reqdata);
      pictop_List.value = res.data.data;
    };
    const data_list = ref([]);
    const get_list = async () => {
      loading.value = true;
      let reqdata = {
        page: page.value.page,
        pageSize: page.value.pageSize,
        title: form.title,
        cate_id: form.cate_id,
        topic_id: form.topic_id,
        type: form.type,
        start_time: date.value[0],
        end_time: date.value[1],
        status: tabsActive.value,
        sort: form.sort
      };
      const res = await getCaseListApi(reqdata);
      total.value = res.data.total;
      data_list.value = res.data.data;
      loading.value = false;
    };
    const ids = ref("");
    function set_multipleSelection(e) {
      // console.log(e[0].id)
      if (e.length) {
        let id = e.map(item => item.id).join(",");
        ids.value = id;
      } else {
        ids.value = "";
      }
    }
    async function init() {
      await pictop_List_s();
      await cate_lists();
      await get_list();
    }
    init();
    //监听tabsActive
    watch(tabsActive, val => {
      page.value.page = 1;
      get_list();
    });
    async function close(e) {
      if (e) {
        emit("pubsnote", e);
      }
      await get_list();
    }
    async function get_list_s(e) {
      if (e) {
        form.sort = e;
        page.value.page = 1;
        get_list();
      }
    }
    async function batchCase_s(status) {
      if (!ids.value) {
        return ElMessage.warning("请选择要操作的数据");
      }
      let reqdata = {
        ids: ids.value,
        status
      };
      const res = await batchCaseApi(reqdata);
      if (res.code == 0) {
        ElMessage.success("操作成功");
        ids.value = "";
        page.value.page = 1;
        get_list();
      }
    }
    async function batchDeleteCase() {
      if (!ids.value) {
        return ElMessage.warning("请选择要操作的数据");
      }
      ElMessageBox.confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await batchDeleteCaseApi({
          ids: ids.value
        });
        if (res.code == 0) {
          ElMessage.success("操作成功");
          ids.value = "";
          page.value.page = 1;
          get_list();
        }
      }).catch(() => {
        ElMessage.warning("已取消删除");
      });
    }
    const contentsRef = ref(null); // 用于存储 DOM 引用
    const heights = ref(0);
    onMounted(() => {
      if (contentsRef.value) {
        heights.value = contentsRef.value.offsetHeight; // 获取高度
        // console.log('Element height:', height);
      }
    });

    function get_heights() {
      return 96 + heights.value;
      // return contentsRef.value.offsetHeight
    }

    return (_ctx, _cache) => {
      const _component_top_title = _resolveComponent("top-title");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_affix = _resolveComponent("el-affix");
      const _component_proto_pagination = _resolveComponent("proto-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_top_title, {
        message: "笔记管理"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        ref_key: "contentsRef",
        ref: contentsRef,
        class: "t_boxs"
      }, [_createVNode(_component_el_form, {
        model: form,
        inline: "",
        "label-width": "auto"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "笔记名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.title = $event),
            placeholder: "请输入笔记名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "分类筛选"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: form.cate_id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.cate_id = $event),
            placeholder: "请选择分类"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cate_List.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "话题筛选"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            filterable: "",
            modelValue: form.topic_id,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.topic_id = $event),
            placeholder: "请选择话题"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pictop_List.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "图文/视频筛选"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            filterable: "",
            modelValue: form.type,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.type = $event),
            placeholder: "请选择类型"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type_List.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "发布时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: date.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => date.value = $event),
            type: "datetimerange",
            "range-separator": "至",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: hald_seach
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "",
            onClick: _cache[5] || (_cache[5] = $event => hald_seach('rest'))
          }, {
            default: _withCtx(() => [_createTextVNode("重置")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: pubnote
      }, {
        default: _withCtx(() => [_createTextVNode("发布笔记")]),
        _: 1
      })])])], 512), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_affix, {
        offset: get_heights()
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tabs, {
          modelValue: tabsActive.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => tabsActive.value = $event),
          class: "demo-tabs"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tablist.value, item => {
            return _openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.name,
              name: item.name,
              label: item.label
            }, null, 8, ["name", "label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, "共" + _toDisplayString(total.value) + "篇笔记", 1), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_tooltip, {
          class: "box-item",
          effect: "light",
          content: "表格展示",
          placement: "top"
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass(["icons iconfont iconyy-biaoge", actives.value == 1 ? 'actives' : '']),
            onClick: _cache[7] || (_cache[7] = $event => actives.value = 1)
          }, null, 2)]),
          _: 1
        }), _createVNode(_component_el_tooltip, {
          class: "box-item",
          effect: "light",
          content: "平铺展示",
          placement: "top"
        }, {
          default: _withCtx(() => [_createElementVNode("i", {
            class: _normalizeClass(["icons iconfont iconyy-pingpu", actives.value == 2 ? 'actives' : '']),
            onClick: _cache[8] || (_cache[8] = $event => actives.value = 2)
          }, null, 2)]),
          _: 1
        })])])])]),
        _: 1
      }, 8, ["offset"]), actives.value == 2 ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data_list.value, (item, index) => {
        return _openBlock(), _createBlock(itemDetile, {
          "item-data": item,
          class: "itemsa",
          key: index,
          onClose: close
        }, null, 8, ["item-data"]);
      }), 128))])), [[_directive_loading, loading.value]]) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(tableList, {
        data_list: data_list.value,
        loading: loading.value,
        onClose: close,
        onGet_list: get_list_s,
        onSet_multipleSelection: set_multipleSelection
      }, null, 8, ["data_list", "loading"])]))]), _createElementVNode("div", _hoisted_10, [actives.value == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", {
        class: "boxs t_s_boxs",
        onClick: _cache[9] || (_cache[9] = $event => batchCase_s(1))
      }, "批量上架"), _createElementVNode("div", {
        class: "boxs t_s_boxs margin-l-10",
        onClick: _cache[10] || (_cache[10] = $event => batchCase_s(2))
      }, " 批量下架 "), _createElementVNode("div", {
        class: "boxs del_boxs margin-l-10",
        onClick: _cache[11] || (_cache[11] = $event => batchDeleteCase())
      }, "批量删除")])) : _createCommentVNode("", true), _createVNode(_component_proto_pagination, {
        page: page.value,
        total: total.value,
        onCurrentChange: get_list
      }, null, 8, ["page", "total"])])])]);
    };
  }
});